import { ComplaintAction } from "./ComplaintActionDTO";
import { ComplaintHistoryDTO } from "./ComplaintHistoryDTO";

export type ComplaintDTO = {
	priority: string;
	id: number;
	companyName: string;
	description: string;
	criteria: string;
	files: string;
	sector: string;
	position: string;
	companyId: string;
	complaintType: string;
	finalType: string;
	status: string;
	createdAt: string;
	classificatedAt: string;
	assignedAt: string;
	finishedAt: string;
	actions: ComplaintAction[];
	history: ComplaintHistoryDTO[];
}

export function priorityId(v: string) {
	switch (v) {
		case 'Crítica':
			return 0;
		case 'Alta':
			return 1;
		case 'Média':
			return 2;
		default:
			return 3;
	}
}